import { Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class WistiaScriptInjectionService {
    private document = inject<Document>(DOCUMENT);

    wistiaLibraryScriptAdded: boolean | undefined;

    injectScript(src: string) {
        if (this.document && src?.trim()) {
            // Get all script tags
            const scriptTagsCollection = document.getElementsByTagName('script');
            // Get last script tag which will be main.js module
            const mainJsScriptTag = scriptTagsCollection[scriptTagsCollection.length - 1];

            // Check if script with same src already exists in DOM
            const trimmedSrc = src.trim();
            // Convert HTMLCollection to Array for iteration
            const scriptTags = Array.from(scriptTagsCollection);
            for (const scriptTag of scriptTags) {
                // For E-v1.js, check if the script src contains the essential part
                if (trimmedSrc.includes('E-v1.js') && scriptTag.src.includes('E-v1.js')) {
                    return false; // E-v1.js script already exists, don't add it again
                }
                // For other scripts, check if they match the exact URL or contain the essential parts
                else if (
                    scriptTag.src === trimmedSrc ||
                    (trimmedSrc.includes('/embed/medias/') &&
                        scriptTag.src.includes(trimmedSrc.split('/embed/medias/')[1]))
                ) {
                    return false; // Script already exists, don't add it again
                }
            }

            // Don't add Wistia library file if already present (additional safeguard)
            if (src.includes('E-v1')) {
                if (!this.wistiaLibraryScriptAdded) {
                    this.wistiaLibraryScriptAdded = true;
                } else {
                    return false;
                }
            }

            // Create Wistia script tag adding src and async attributes
            const script = this.document.createElement('script');
            script.setAttribute('src', src.trim());
            script.setAttribute('async', String(true));

            // Insert Wistia script tag before main.js module file
            if (mainJsScriptTag && mainJsScriptTag.parentNode) {
                mainJsScriptTag.parentNode.insertBefore(script, mainJsScriptTag);
            }
            return true;
        } else {
            return false;
        }
    }
}
